import { Component } from '@angular/core';

@Component({
    selector: 'nio-digital-workspace-orange-unified-school-district',
    templateUrl: './digital-workspace-orange-unified-school-district.component.html',
    styleUrls: [
        './digital-workspace-orange-unified-school-district.component.scss',
    ],
    standalone: false
})
export class DigitalWorkspaceOrangeUnifiedSchoolDistrictComponent {}
